// --- START OF FILE AcessosStyle.js ---

import styled from "styled-components";

// Usando o mesmo padrão de luxo das outras páginas
export const ClientsContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h2 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
    }
`;

// ÁREA DE FILTROS
export const FilterArea = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
    align-items: flex-end;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const SearchBar = styled.div`
    display: flex;
    
    input {
        flex-grow: 1;
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 20px;
        color: #fff;
        border-radius: 6px 0 0 6px;
        &:focus { outline: none; border-color: #E6AA3A; }
    }
    
    button {
        width: 60px;
        height: 45px;
        border: none;
        background: #E6AA3A;
        color: #111;
        cursor: pointer;
        border-radius: 0 6px 6px 0;
    }
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    label {
        font-size: 12px;
        color: #fff;
        opacity: 0.8;
        text-transform: uppercase;
    }

    select {
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 15px;
        color: #fff;
        border-radius: 6px;
    }
`;

// TABELA
export const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr`
    color: rgba(255,255,255,0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    &:first-child { /* Header Row */
        background-color: rgba(0,0,0,0.2);
        border-bottom: 2px solid #E6AA3A;
    }
`;

export const TableHeaderCell = styled.th`
    padding: 15px;
    text-align: left;
    white-space: nowrap;
    color: #fff;
    font-weight: 600;
`;

export const TableBody = styled.tbody``;
export const TableCell = styled.td`
    padding: 15px;
    text-align: left;
    white-space: nowrap;
`;

// PAGINAÇÃO
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 15px;
    color: #fff;
`;

export const PaginationButton = styled.button`
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover:not(:disabled) {
        background: #E6AA3A;
        color: #111;
        border-color: #E6AA3A;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

// Componentes legados para manter a estrutura do seu JSX
export const ClientFirstContent = styled.div``;
export const AreaTitle = styled.h2`
    margin: 0;
    color: #E6AA3A;
    font-size: 28px;
`;
export const Clients = styled.div``;
export const SearchOrdem = styled.div``;
export const ClientsTable = styled.div``;